import { baseApi } from "../redux/baseAPI";

export const referralApi = baseApi.injectEndpoints({
  tagTypes: ["ReferralMeta"],
  endpoints: (builder) => ({
    getReferralsMeta: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_referrals/meta.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["ReferralMeta"],
    }),
    searchIcd: builder.query({
      query: (keyword) => {
        let params = "";
        if (typeof keyword == "object") {
          params = `keyword=${keyword.keyword}&pid=${keyword.pid}`;
        } else {
          params = `keyword=${keyword}`;
        }
        return {
          url: `/ccm/get_health_conditions_icds.json?${params}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    requestReferral: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_referrals/request.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    getPatientProblems: builder.query({
      query: (data) => {
        return {
          url: `/ccm/get_health_conditions.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["PatientProblem"],
    }),
    addConsent: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_consents/add.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    searchExternalProvider: builder.query({
      query: (data) => {
        return {
          url: `/external_providers/lookup.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    searchSpecialty: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_referrals/listing/specialty.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    addExternalProvider: builder.mutation({
      query: (body) => ({
        url: `/external_providers/add.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
  }),
});

export const {
  useGetReferralsMetaQuery,
  useSearchIcdQuery,
  useRequestReferralMutation,
  useGetPatientProblemsQuery,
  useAddConsentMutation,
  useSearchExternalProviderQuery,
  useSearchSpecialtyQuery,
  useAddExternalProviderMutation
} = referralApi;
